import { ActionType, MoldOrder } from '@/types/mold';
import ActionButton from './ActionButton';

type AcceptStyle = 'approve' | 'submit';

interface ApprovalButtonsProps {
    moldOrder: MoldOrder;
    handleActionClick: (action: ActionType, acceptStyle: AcceptStyle, messageOverride?: {submit?: string; reject?: string;}) => void;
    acceptLabel?: string;
    acceptStyle?: AcceptStyle;
    rejectLabel?: string;
}
const ApprovalButtons: React.FC<ApprovalButtonsProps> = ({
    moldOrder,
    handleActionClick,
    acceptLabel = 'อนุมัติ',
    acceptStyle = 'approve',
    rejectLabel = 'ปฏิเสธ',
}) => {
    // Check if approval is required and still pending
    const isApprovalRequired = moldOrder.currentStateApproval?.approvalRequired;
    const isApprovalPending = moldOrder.currentStateApproval?.approvalStatus === 'pending';
    // If approval is required and pending, don't show approval buttons
    if (isApprovalRequired && isApprovalPending) {
        return <></>;
    }

    if (moldOrder.transitionActions && moldOrder.transitionActions?.length > 0) {
        const actions = moldOrder.transitionActions
        const uiConfig = {
            accept: {
                label: acceptLabel,
                buttonType: (acceptStyle === 'submit') ? 'acceptNext' : 'acceptApprove',
                testIdIdentifier: 'accept-button',
            },
            rework: {
                label: 'ส่งกลับเพื่อแก้ไข',
                buttonType: 'rework',
                testIdIdentifier: 'rework-button',
            },
            reject: {
                label: rejectLabel,
                buttonType: 'reject',
                testIdIdentifier: 'reject-button',
            },
        }
        return <div className="flex flex-col gap-2" data-cy="approval-buttons" data-testid="approval-buttons">
            {actions.map((transitionAction) => {
                const config = uiConfig[transitionAction.action];
                const overrideMessages = {
                    submit: acceptLabel,
                    reject: rejectLabel,
                };
                return <ActionButton
                    key={transitionAction.action}
                    buttonText={config.label}
                    buttonType={config.buttonType as 'acceptApprove' | 'reject' | 'rework'}
                    testIdIdentifier={config.testIdIdentifier}
                    disable={!transitionAction.isAllowed}
                    onClick={() => handleActionClick(transitionAction.action, acceptStyle, overrideMessages)} />
            })}
        </div>
    }
    return <></>
}

export default ApprovalButtons;